import { render, staticRenderFns } from "./notesInfo.vue?vue&type=template&id=4ec7ef17&scoped=true&"
import script from "./notesInfo.vue?vue&type=script&lang=js&"
export * from "./notesInfo.vue?vue&type=script&lang=js&"
import style0 from "./notesInfo.vue?vue&type=style&index=0&id=4ec7ef17&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec7ef17",
  null
  
)

export default component.exports